/* eslint-disable */
import * as React from "react";
import { useTranslation } from "react-i18next";

//MUI Icons
import AddBoxIcon from "@mui/icons-material/AddBox";

//Custom components
import CardToolbarMenuItem from "@/ui/Card/CardToolbarMenuItem";

//Types
import { ICardToolbarMenuItemDetail } from "@/@types/ui/Card";

const CardToolbarMenuItemCopy = React.forwardRef<HTMLLIElement, ICardToolbarMenuItemDetail>((props, ref) => {
  const { t } = useTranslation();
  const { onClick } = props;

  return <CardToolbarMenuItem label={t("buttons.copy")} icon={<AddBoxIcon />} onClick={onClick} ref={ref} />;
});

export default CardToolbarMenuItemCopy;
